import { computed, ref } from 'vue';
import { useLimitsStore } from '@/stores';

export function useTimer(maxSessionTimeInSeconds: number | null) {
    const limitsStore = useLimitsStore();
    const remainingTime = ref<number>(0);
    const timerInterval = computed(() => {
        return limitsStore.timerInterval;
    });

    function updateLocalStorage() {
        if (remainingTime.value > 0) {
            localStorage.setItem('remainingTimeInSeconds', remainingTime.value.toString());
            const endTime = Date.now() + remainingTime.value * 1000;
            localStorage.setItem('endTime', endTime.toString());
        }
    }

    function checkTime() {
        if (remainingTime.value <= 0) {
            limitsStore.toSetLimitsData({ modal: true }, 'sessionFlag');
            stopTimer();
            remainingTime.value = 0;
        } else {
            remainingTime.value -= 1;
            updateLocalStorage();
        }
    }

    function startTimer() {
        if (timerInterval.value || maxSessionTimeInSeconds === null) {
            return;
        }

        const storedRemainingTime = localStorage.getItem('remainingTimeInSeconds');
        const storedEndTime = localStorage.getItem('endTime');

        if (storedRemainingTime && storedEndTime) {
            const endTime = parseInt(storedEndTime, 10);
            const now = Date.now();
            const calculatedRemainingTime = Math.max(Math.floor((endTime - now) / 1000), 0);

            if (calculatedRemainingTime > 0) {
                remainingTime.value = calculatedRemainingTime;
            } else {
                remainingTime.value = maxSessionTimeInSeconds;
            }
        } else {
            remainingTime.value = maxSessionTimeInSeconds!;
        }

        limitsStore.toSetTimerInterval(setInterval(checkTime, 1000));
        updateLocalStorage();
    }

    function stopTimer() {
        clearTimerInterval();
        localStorage.removeItem('endTime');
        localStorage.removeItem('remainingTimeInSeconds');
        remainingTime.value = 0;
    }

    function clearTimerInterval() {
        if (timerInterval.value !== null) {
            clearInterval(timerInterval.value);
            limitsStore.toSetTimerInterval(null);
        }
    }

    return {
        remainingTime,
        startTimer,
        stopTimer
    };
}
